import React from "react";
import { Card, Typography } from "antd";
import "./InfoCard.css";
import Loader from "../../../Loader/Loader";

const { Text } = Typography;

const InfoCard = ({ statistic, isLoading, href }) => {
  const cardClass = statistic.type ? `${statistic.type}-card` : "white-card";
  const isClickable = Boolean(href);

  const handleClick = () => {
    if (href) {
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Card
      className={`info-card ${cardClass} ${isClickable ? "info-card-clickable" : ""}`}
      onClick={isClickable ? handleClick : undefined}
      style={isClickable ? { cursor: "pointer" } : undefined}
    >
      <div className="info-card-content">
        {isLoading ? (
          <Loader />
        ) : statistic.value ? (
          <>
            <div className={`value-container ${statistic.valueVariant === "longText" ? "value-container--long-text" : ""}`}>
              <Text className={`value-text ${statistic.valueVariant === "longText" ? "value-text--long" : ""}`}>{statistic.value}</Text>
              {statistic.unit && (
                <Text className="unit-text">{statistic.unit}</Text>
              )}
            </div>
            <Text className="description-text">{statistic.title}</Text>
          </>
        ) : (
          <div className="no-results-container">
            <span className="no-results-text">No results found.</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default InfoCard;
